export default class StampedService {
    static getRating(): Promise<any> {
        return fetch(`https://stamped.io/api/widget/reviews?storeUrl=${116346}&minRating=${1}`).then(response => response.json());
    }
}